<template>
  <div class="dash-preview">
    <div class="container">
      <div class="row collage-photo" style="margin-top: -40px">
        <div class="col-6 col-sm-6 col-lg-4 col-xl-3" v-for="(index) in 2" :key="index">
          <div class="collage-photo-item">
            <div class="collage-photo-item__image-container cursor-default">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row-small-gutters">
        <div class="col mt-3 mt-lg-0 text-center">
          <template v-if="(data.link || data.email) && data.banner">
            <a :href="bannerAction" target="_blank">
              <div class="checkin-banner__image-w">
                <img :src="data.banner" alt="Banner" class="img-fluid cursor-pointer checkin-banner__image">
              </div>
            </a>
          </template>
          <template v-else-if="data.banner">
            <div class="checkin-banner__image-w">
              <img :src="data.banner" alt="Banner" class="img-fluid checkin-banner__image">
            </div>
          </template>
          <template v-else>
            <div class="collage-photo-item d-flex align-items-center justify-content-center" style="min-height: 300px">
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PreviewBanner',

  props: {
    data: {
      type: Object,
      required: false
    }
  },
  computed: {
    bannerAction() {
      return this.data.link ? this.data.link : `mailto:${this.data.email}`
    }
  }
}
</script>
